import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

import {  Apitoken, Authtoken } from "../Global";
const BankAccountTransactionView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  const [valuepayment, setValuepayment] = useState([]);

  const [currencySymbol, setCurrencySymbol] = useState('');
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  useEffect(() => {
        setPermission(FindModuleById(446)); 
console.log(permission);

    raw_data_invoice ='';

    axios
      .get(`/expenses/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.expense);
          axios.get(`/expenses/view-payments/${id}`, {
           headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
         })
         .then((response) => {
           if (response.data.code === 200) {
            console.log(response.data.data.payments);
            setValuepayment(response.data.data.payments);
           
           }
         })
         .catch((error) => {
           console.log(error);
         });


         setValue(response.data.data.expense);
         axios.get(`/helper/currency-symbol-by-currency-id/${response.data.data.expense.currency}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            setCurrencySymbol(response.data.data.currency_symbol)
          
          }
        })
        .catch((error) => {
          console.log(error);
        });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    
  }, [id]);


  let raw_data_invoice ='';
  if(value.invoice_attachment){
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: value.invoice_attachment};
    raw_data_invoice = s3.getSignedUrl('getObject', params);
  
  }
  
  console.log(valuepayment);


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Bank Account Transaction</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/expenses">Bank Account Transaction</Link>
                    </li>
                    <li className="breadcrumb-item active">View</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">View Bank Account Transaction</h4>
                    {permission && permission.list === 1 && (

                    <table className="table table-bordered">
                    <tr>
                        <th className="p-3">Invoice Number</th>
                        <td className="p-3">{value.invoice_number}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Invoice Date</th>
                        <td className="p-3">{value.invoice_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Paid To</th>
                        <td className="p-3">{value.paid_to}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Invoice Due Date</th>
                        <td className="p-3">{value.invoice_due_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Supplier</th>
                        <td className="p-3">
                          {value.supplier_detail
                            ? value.supplier_detail.name
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Designation</th>
                        <td className="p-3">{value.designation}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Amount HT</th>
                        <td className="p-3">{value.amount_ht}{currencySymbol}</td>
                      </tr>
                       <tr>
                        <th className="p-3">TVA Rate</th>
                        <td className="p-3">{value.tva_rate}%</td>
                      </tr>
                      <tr>
                        <th className="p-3">Total Amount TTC</th>
                        <td className="p-3">{value.total_amount_ttc}{currencySymbol}</td>
                      </tr>
                      <tr>
                        <th className="p-3">TVA Amount </th>
                        <td className="p-3">{value.tva_amount}{currencySymbol}</td>
                      </tr>
                      {/* <tr>
                        <th className="p-3">Total Amount</th>
                        <td className="p-3">{value.total_amount}{currencySymbol}</td>
                      </tr> */}
                     
                      <tr>
                        <th className="p-3">Expense Type</th>
                        <td className="p-3">
                          {value.type
                            ? value.type.title
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Payment Method</th>
                        <td className="p-3">{value.payment_method}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Payment Status</th>
                        <td className="p-3">
                          {value.payment_status}
                        </td>
                      </tr>
                      {raw_data_invoice != '' && (
                          <tr>
                          <th className="p-3">Invoice Attachment</th>
                          <td className="p-3">
                            <a
                              className="btn btn-primary invoicebtn"
                              href={raw_data_invoice}
                              target="_blank"
                              download
                              rel="noreferrer"
                            >
                              Download
                            </a>
                          </td>
                        </tr>
                      )}
                       <tr>
                        <th className="p-3">Payment Note</th>
                        <td className="p-3">{value.payment_note}</td>
                      </tr>
                    </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BankAccountTransactionView;
